<!--MODIFY /view/layout/aside/Menu.vue TO DYNAMICALLY LOAD THIS FILE -->
<template>
  <div>
    <li class="menu-section">
      <h4 class="menu-text">Sales</h4>
      <i class="menu-icon flaticon2-menu-4"></i>
    </li>

    <router-link
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
        aria-haspopup="true"
        class="menu-item"
        data-menu-toggle="hover"
      >
        <a :href="href" @click="navigate" class="menu-link">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">Dashboard</span>
        </a>
      </li>
    </router-link>
  </div>

  <!--  <li-->
  <!--    aria-haspopup="true"-->
  <!--    class="menu-item menu-item-submenu"-->
  <!--    data-menu-toggle="hover"-->
  <!--    v-bind:class="{ 'menu-item-open': hasActiveChildren('/easyreceipt') }"-->
  <!--    v-if="hasUser === true"-->
  <!--  >-->
  <!--    <a class="menu-link menu-toggle" href="#">-->
  <!--      <i class="menu-icon flaticon2-menu-4"></i>-->
  <!--      <span class="menu-text">Easy Receipt</span>-->
  <!--      <i class="menu-arrow"></i>-->
  <!--    </a>-->
  <!--    <div class="menu-submenu">-->
  <!--      <span class="menu-arrow"></span>-->
  <!--      <ul class="menu-subnav">-->
  <!--        <router-link-->
  <!--          :to="{ name: 'easyreceipt-applications' }"-->
  <!--          v-slot="{ href, navigate, isActive, isExactActive }"-->
  <!--        >-->
  <!--          <li-->
  <!--            :class="[-->
  <!--              isActive && 'menu-item-active',-->
  <!--              isExactActive && 'menu-item-active'-->
  <!--            ]"-->
  <!--            aria-haspopup="true"-->
  <!--            class="menu-item"-->
  <!--            data-menu-toggle="hover"-->
  <!--          >-->
  <!--            <a :href="href" @click="navigate" class="menu-link">-->
  <!--              <i class="menu-bullet menu-bullet-dot">-->
  <!--                <span></span>-->
  <!--              </i>-->
  <!--              <span class="menu-text">ATG Applications</span>-->
  <!--            </a>-->
  <!--          </li>-->
  <!--        </router-link>-->
  <!--        <router-link-->
  <!--          :to="{ name: 'easyreceipt-profile' }"-->
  <!--          v-slot="{ href, navigate, isActive, isExactActive }"-->
  <!--        >-->
  <!--          <li-->
  <!--            :class="[-->
  <!--              isActive && 'menu-item-active',-->
  <!--              isExactActive && 'menu-item-active'-->
  <!--            ]"-->
  <!--            aria-haspopup="true"-->
  <!--            class="menu-item"-->
  <!--            data-menu-toggle="hover"-->
  <!--          >-->
  <!--            <a :href="href" @click="navigate" class="menu-link">-->
  <!--              <i class="menu-bullet menu-bullet-dot">-->
  <!--                <span></span>-->
  <!--              </i>-->
  <!--              <span class="menu-text">My Business Info</span>-->
  <!--            </a>-->
  <!--          </li>-->
  <!--        </router-link>-->
  <!--      </ul>-->
  <!--    </div>-->
  <!--  </li>-->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "menuTopup",
  components: {},
  computed: {
    ...mapGetters(["layoutConfig", "currentUser", "currentUserRoles"]),
    hasUser: function() {
      let retVal = false;
      if (this.currentUserRoles)
        retVal = this.currentUserRoles.indexOf("user") !== -1;
      return retVal;
    }
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
